import axios from "axios";
import React from "react";
import { baseURL } from "../Config/Config";
import "./Umumiy.css";
import { Link } from "react-router-dom";

export default function Umumiy() {

  const [items, setItems] = React.useState();

  React.useEffect(() => {
    axios.get(`${baseURL}rtr_base_app/statistika`).then((response) => {
      setItems(response.data);
    }).catch((err) => {
      console.log(err)
    })
  }, []);
  if (!items) return null;

  return (
    <div className="umumiy">
      <div className="container">
        <div className="umumiycards">
          <div className="umumiycard">
            <svg
              width="37"
              height="32"
              viewBox="0 0 37 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.0865627 32H7.37656V0.499998H0.0865627V32ZM14.8522 32H22.1422V0.499998H14.8522V32ZM29.6178 32H36.9078V0.499998H29.6178V32Z"
                fill=""
              />
            </svg>
            <div className="name">
              <p>Boshlang’ich kasbiy ta’lim</p>
              <span>{items.boshlangich} fan</span>
            </div>
          </div>
          <div className="umumiycard">
            <svg
              width="46"
              height="32"
              viewBox="0 0 46 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.152969 32H7.44297V0.499998H0.152969V32ZM37.7828 0.499998L28.0628 23L18.4778 0.499998H10.6028L24.1928 32H31.3928L45.0278 0.499998H37.7828Z"
                fill=""
              />
            </svg>

            <div className="name">
              <p>O'rta kasbiy ta'lim</p>
              <span>{items.orta} fan</span>
            </div>
          </div>
          <div className="umumiycard">
            <svg
              width="36"
              height="32"
              viewBox="0 0 36 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M27.9879 0.499998L18.2679 23L8.68289 0.499998H0.807891L14.3979 32H21.5979L35.2329 0.499998H27.9879Z"
                fill=""
              />
            </svg>

            <div className="name">
              <p>O’rta maxsus kasbiy ta’lim</p>
              <span>{items.maxsus} fan</span>
            </div>
          </div>
          <div className="umumiycard">
            <svg
              width="48"
              height="41"
              viewBox="0 0 48 41"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M42.5886 8.52529H37.519V3.45567C37.519 2.55931 37.1629 1.69966 36.5291 1.06583C35.8953 0.432007 35.0356 0.0759277 34.1392 0.0759277H13.8608C12.9644 0.0759277 12.1047 0.432007 11.4709 1.06583C10.8371 1.69966 10.481 2.55931 10.481 3.45567V8.52529H5.41139C4.06685 8.52529 2.77737 9.05941 1.82663 10.0102C0.875893 10.9609 0.341774 12.2504 0.341774 13.5949V37.2531C0.341774 38.1495 0.697853 39.0092 1.33168 39.643C1.9655 40.2768 2.82516 40.6329 3.72152 40.6329H44.2785C45.1748 40.6329 46.0345 40.2768 46.6683 39.643C47.3021 39.0092 47.6582 38.1495 47.6582 37.2531V13.5949C47.6582 12.2504 47.1241 10.9609 46.1734 10.0102C45.2226 9.05941 43.9332 8.52529 42.5886 8.52529ZM13.8608 3.45567H34.1392V8.52529H13.8608V3.45567ZM44.2785 37.2531H3.72152V22.0443H17.2405V30.4936H30.7595V22.0443H44.2785V37.2531ZM20.6203 22.0443H27.3797V27.1139H20.6203V22.0443ZM3.72152 18.6645V13.5949C3.72152 13.1467 3.89956 12.7169 4.21647 12.4C4.53339 12.0831 4.96321 11.905 5.41139 11.905H42.5886C43.0368 11.905 43.4666 12.0831 43.7835 12.4C44.1004 12.7169 44.2785 13.1467 44.2785 13.5949V18.6645H3.72152Z"
                fill=""
              />
            </svg>

            <div className="name">
              <p>Professiogrammalar</p>
              <span>{items.professiogamma} ta</span>
            </div>
          </div>
          <div className="umumiycard">
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 16H4V40C4 41.0609 4.42143 42.0783 5.17157 42.8284C5.92172 43.5786 6.93913 44 8 44H32V40H8V16Z"
                fill="#00A0C1"
              />
              <path
                d="M40 4H16C14.9391 4 13.9217 4.42143 13.1716 5.17157C12.4214 5.92172 12 6.93913 12 8V32C12 33.0609 12.4214 34.0783 13.1716 34.8284C13.9217 35.5786 14.9391 36 16 36H40C41.0609 36 42.0783 35.5786 42.8284 34.8284C43.5786 34.0783 44 33.0609 44 32V8C44 6.93913 43.5786 5.92172 42.8284 5.17157C42.0783 4.42143 41.0609 4 40 4ZM22 28V12L36 20L22 28Z"
                fill="#00A0C1"
              />
            </svg>

            <div className="name">
              <p>Video materiallar</p>
              <span>{items.video} ta</span>
            </div>
          </div>
          <div className="umumiycard">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="48"
              viewBox="0 96 960 960"
              width="48"
            >
              <path d="M0 816v-53q0-38.567 41.5-62.784Q83 676 150.376 676q12.165 0 23.395.5Q185 677 196 678.652q-8 17.348-12 35.165T180 751v65H0Zm240 0v-65q0-32 17.5-58.5T307 646q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-19.861-3.5-37.431Q773 696 765 678.727q11-1.727 22.171-2.227 11.172-.5 22.829-.5 67.5 0 108.75 23.768T960 763v53H780Zm-480-60h360v-6q0-37-50.5-60.5T480 666q-79 0-129.5 23.5T300 751v5ZM149.567 646Q121 646 100.5 625.438 80 604.875 80 576q0-29 20.562-49.5Q121.125 506 150 506q29 0 49.5 20.5t20.5 49.933Q220 605 199.5 625.5T149.567 646Zm660 0Q781 646 760.5 625.438 740 604.875 740 576q0-29 20.562-49.5Q781.125 506 810 506q29 0 49.5 20.5t20.5 49.933Q880 605 859.5 625.5T809.567 646ZM480 576q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600 456q0 50-34.5 85T480 576Zm.351-60Q506 516 523 498.649t17-43Q540 430 522.851 413t-42.5-17Q455 396 437.5 413.149t-17.5 42.5Q420 481 437.351 498.5t43 17.5ZM480 756Zm0-300Z" />
            </svg>

            <div className="name">
              <p>Foydalanuvchilar</p>
              <span>{items.users} nafar</span>
            </div>
          </div>
        </div>
      </div>
      <div className="umumiy-right">
        <Link to={"#"}>Foydalanuvchilar uchun video yoriqnoma</Link>
      </div>
    </div>
  );
}
